export enum MouseEventType {
  Enter = 'enter',
  Leave = 'leave',
}
